import { useIsMobileDevice } from './useIsMobileDevice'
import { useScreenSizeOnly } from './useScreenSize'

export type ShareVariant = 'modalShare' | 'nativeShare'

function useShareVariant(): ShareVariant {
  const isMobileDevice = useIsMobileDevice()

  const isTabletScreen = useScreenSizeOnly('tablet')

  // Use native share on mobile web and tablet; keep modal on desktop
  if (isMobileDevice || isTabletScreen) return 'nativeShare'

  return 'modalShare'
}

export default useShareVariant
